import { getI18nPageProps } from "@utils/translates";
import type { PageWithLayout } from "@types";
import { getLayout as getDefaultLayout } from "@layouts/default-layout";
import { setContext } from "@utils/Cookies";
import InstructorApi from "@features/instructor/helpers/instructorApi";
import { GetServerSideProps } from "next";
import {
  getStringQueryParam,
  isSsrDisabled,
} from "@features/instructor/helpers/functions";
import {
  InstructorPaginationLimit,
  productSearchExplore,
} from "@features/instructor/helpers/constants";
import InstructorPage from "@features/instructor/page";
import { EXPLORE_SORT } from "enums/new-explore/explore-sort";
import { setNotFoundResponse } from "lib/ssr/not-found";

const Instructor: PageWithLayout<{ is404?: boolean }> = ({ is404 }) => {
  return <InstructorPage is404={is404} />;
};

Instructor.getLayout = (page, props) =>
  getDefaultLayout(page, { ...props }, {});

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { query, res, req } = ctx;
  const i18nProps = await getI18nPageProps(ctx, "instructors");

  setContext(ctx);

  if (isSsrDisabled(req.headers["x-ssr-activate"])) {
    return { props: { ...i18nProps } };
  }

  const slug = getStringQueryParam(query.slug);
  if (!slug) {
    setNotFoundResponse(res);
    return { props: { ...i18nProps, is404: true } };
  }

  try {
    const instructorKey = InstructorApi.instructorDetail(slug);
    const instructorResponse = await instructorKey.fetch();
    const instructorReq = productSearchExplore({
      page: Number(query.page) || 1,
      sort: (query.sort as EXPLORE_SORT) || EXPLORE_SORT.MOST_SOLD,
      count: InstructorPaginationLimit,
      instructor_id: String(instructorResponse.data.id),
      bypass_exclusion: 1,
    });
    const productResponse = await instructorReq.fetch();

    return {
      props: {
        ...i18nProps,
        fallback: {
          [instructorKey.key()]: instructorResponse,
          [instructorReq.key()]: productResponse,
        },
      },
    };
  } catch (error: any) {
    if (error?.error?.code === 404) {
      setNotFoundResponse(res);
    }
    return { props: { ...i18nProps, is404: error?.error?.code === 404 } };
  }
};

export default Instructor;
